export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref7060.898b4f33.jpg";